import { TabList } from '@reach/tabs';
import classNames from 'classnames';
import * as React from 'react';
import { Experiments, PlanType, Theme } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { TabButton } from './TabButton';
import s from './Tabs.scss';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';

interface TabButtonsCompProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const tabsDescription = {
  [Theme.AdvancedPlans]: {
    website: 'Advanced.Plans_Tabs_Website_subheader',
    business: 'Advanced.Plans_Tabs_Business_subheader',
    enterprise: 'enterprise_plans.tab.subtitle',
  },
  [Theme.WixStudio]: {
    website: 'Advanced.Plans_Tabs_Website_subheader',
    business: 'Advanced.Plans_Tabs_Business_subheader',
    enterprise: 'enterprise_plans.tab.subtitle',
  },
  [Theme.EditorX]: {
    website: 'Editorx.Plans_Tabs_Website_subheader',
    business: 'Editorx.Plans_Tabs_Business_subheader',
    enterprise: 'enterprise_plans.tab.subtitle',
  },
  [Theme.Dayful]: {
    website: 'Editorx.Plans_Tabs_Website_subheader',
    business: 'Editorx.Plans_Tabs_Business_subheader',
    enterprise: 'enterprise_plans.tab.subtitle',
  },
};

const TabButtonsComp: React.FC<TabButtonsCompProps> = ({
  rootStore,
  experiments,
}) => {
  const {
    appStore: {
      isInSale,
      appContext: { isLimitedTimeDiscount },
      planType,
    },
  } = rootStore;
  const { theme } = usePageModeContext();
  const isEnterpriseTabEnabled = experiments.enabled(
    Experiments.AddEnterpriseTab,
  );

  const websiteTabsDescription =
    tabsDescription[theme].website ||
    tabsDescription[Theme.AdvancedPlans].website;

  const businessTabsDescription =
    tabsDescription[theme].business ||
    tabsDescription[Theme.AdvancedPlans].business;

  const enterpriseTabsDescription =
    tabsDescription[theme].enterprise ||
    tabsDescription[Theme.AdvancedPlans].enterprise;

  return (
    <TabList
      className={classNames(s.tabs, {
        [s.limitedTimeOffer]: isLimitedTimeDiscount,
        [s.saleBackground]: isInSale,
        [s.threeTabsWidth]: isEnterpriseTabEnabled,
        [s.enterpriseSelected]: planType === PlanType.Enterprise,
      })}
    >
      <TabButton
        dataTestId='website-tab-button'
        isInSale={isInSale}
        title='Advanced.Plans_Tabs_Website_title'
        description={websiteTabsDescription}
      />
      <TabButton
        dataTestId='business-tab-button'
        isInSale={isInSale}
        title='Advanced.Plans_Tabs_Business_title'
        description={businessTabsDescription}
      />
      {isEnterpriseTabEnabled && (
        <TabButton
          dataTestId='enterprise-tab-button'
          isInSale={isInSale}
          title='enterprise_plans.tab.title'
          description={enterpriseTabsDescription}
        />
      )}
    </TabList>
  );
};

export const TabButtons = withInjectedRootStore(
  withExperiments(TabButtonsComp),
);
